import { SidenavItemInterface } from "src/app/shared/side-nav/interfaces/side-nav-items.interface";

export const managementSideNavConfig: SidenavItemInterface[] = [
  {
    id: 'recipients',
    label: 'recipients',
    routerLink: '/recipients',
    // permissions: ['VIEW_RECIEPENT'],
  },
  {
    id: 'providers',
    label: 'providers',
    routerLink: '/providers',
    // permissions: ['VIEW_PROVIDER'],
  },
  {
    id: 'transactions',
    label: 'transactions',
    routerLink: '/transactions',
    // permissions: ['VIEW_TRANSACTION'],
  },
  {
    id: 'applications',
    label: 'applications',
    routerLink: '/applications',
    // permissions: ['VIEW_APPLICATIONS'],
  },
  {
    id: 'subscriptions',
    label: 'subscriptions',
    routerLink: '/subscriptions',
    // permissions: ['VIEW_SUBSCRIPTION'],
  },
  {
    id: 'accounts',
    label: 'accounts',
    routerLink: '/accounts',
    // permissions: ['VIEW_SUBSCRIPTION'],
  },
  {
    id: 'masri-credit-report',
    label: 'masri_info_report',
    routerLink: '/masri-info-report',
    // permissions: ['VIEW_SUBSCRIPTION'],
  },
  {
    id: 'ratings',
    label: 'ratings',
    routerLink: '/ratings',
  },
  {
    id: 'payments',
    label: 'payments',
    routerLink: '/payments',
  },

];
